import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import Row, { Col } from 'components/row';
import Link from 'components/link';
import Icon, { iconTypes } from 'components/icon';

import img from './assets/newbuilds-to-banner-telegram.jpg';

import translates from './banner-telegram-i18n.json';

import config from '../../../../config';

import 'styles/bild/blocks/static/_banner-telegram.scss';

const bemClasses = new Bem('bannerTelegram');

@I18nHoc(translates)
export default class BannerTelegram extends Component {
  static propTypes = {
    className: PropTypes.string,
    dataGtmItemPlace: PropTypes.string
  };

  render() {
    const { i18n } = this;
    const { className, dataGtmItemPlace } = this.props;
    const urlToTelegram = config.telegramlink.url;

    return (
      <div {...bemClasses({ extra: className })}>
        <Link
          {...bemClasses('link', 'fill')}
          href={urlToTelegram}
          title={i18n('goToChannel')}
          dataProps={dataGtmItemPlace ? { 'data-gtm-item': `telegram-${dataGtmItemPlace}` } : null}
          // noRedirector
          external
          blank
          children={<span />}
        />
        <Row {...bemClasses('row', 'main')} alignIcenter mtColumn mpColumn>
          <Col {...bemClasses('col', 'img')} allPr={0} mt={0} mp={0}>
            <div {...bemClasses('imgContainer')}>
              <img {...bemClasses('img')} src={img} alt={i18n('topic')} loading="lazy" decoding="async" />
            </div>
          </Col>
          <Col {...bemClasses('col', 'info')} allPr={0}>
            <Row {...bemClasses('row', 'top')} alignIcenter>
              <Col {...bemClasses('col', 'icon')} allPr={0}>
                <Icon {...bemClasses('icon', 'cat')} type={iconTypes.catDemanding} />
              </Col>
              <Col {...bemClasses('col', 'topic')} allPr={0}>
                <div {...bemClasses('topic')}>
                  <span {...bemClasses('text', 'topic')} children={i18n('topic')} />
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row', 'center')} alignIcenter allColumn>
              <Col {...bemClasses('col', 'description')} allPr={0}>
                <span {...bemClasses('text', 'description')} children={i18n('description')} />
              </Col>
            </Row>
            <Row {...bemClasses('row', 'bottom')} alignIcenter mtColumn mpColumn>
              <Col {...bemClasses('col', 'list')} allPr={0}>
                <ul {...bemClasses('list')}>
                  <li {...bemClasses('listItem')}>
                    <span {...bemClasses('text', 'list')} children={i18n('listItem1')} />
                  </li>
                  <li {...bemClasses('listItem')}>
                    <span {...bemClasses('text', 'list')} children={i18n('listItem2')} />
                  </li>
                  <li {...bemClasses('listItem')}>
                    <span {...bemClasses('text', 'list')} children={i18n('listItem3')} />
                  </li>
                  <li {...bemClasses('listItem')}>
                    <span {...bemClasses('text', 'list')} children={i18n('listItem4')} />
                  </li>
                </ul>
              </Col>
              <Col {...bemClasses('col', 'telegram')} allPr={0}>
                <div {...bemClasses('telegram')}>
                  <Icon {...bemClasses('icon', 'telegram')} type={iconTypes.telegramFill} />
                  <span {...bemClasses('text', 'telegram')} children={i18n('goToChannel')} />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}
